import { render, staticRenderFns } from "./LoginMFA.vue?vue&type=template&id=3980f956&scoped=true"
import script from "./LoginMFA.vue?vue&type=script&lang=js"
export * from "./LoginMFA.vue?vue&type=script&lang=js"
import style0 from "./LoginMFA.vue?vue&type=style&index=0&id=3980f956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3980f956",
  null
  
)

export default component.exports